DO.Subscribe('app:ready', (e, $) => {
  function setInitialHistoryState() {
    if (!window.history.state) {
      window.history.replaceState({ start: 0 }, '', window.location.href);
    }
  }

  function getParams() {
    return window.location.search
      .split(/(\?|&)+/)
      .filter(fraction => fraction.includes('='))
      .map(fraction => fraction.split('='))
      .reduce((acc, cur) => ({ ...acc, [cur[0]]: cur[1] }), {});
  }

  function getCategoryFormUrl() {
    const params = getParams();
    return params.category ? params.category : null;
  }

  function clickOnFilterLink(urlCategory) {
    if (urlCategory) {
      const filterLink = $(`#taglist-link-${urlCategory}`);
      if (filterLink[0]) {
        filterLink.click();
        return;
      }
    }
    $('#taglist-link-all').click();
  }

  function updateFilterLinkClasses(link) {
    $('.taglist-link').removeClass('taglist-link--current');
    $('.taglist-item').removeClass('taglist-item--current');
    link.addClass('taglist-link--current');
    link.parent('.taglist-item').addClass('taglist-item--current');
  }

  function pushState(link, url, selector, category) {
    const linkId = link.attr('id');
    window.history.pushState({
      linkId, url, selector, category,
    }, '', url);
  }

  function handleAjax(url, target, reset) {
    $.ajax({
      url,
      type: 'GET',
      success(result) {
        if (result.indexOf('listgrid-item--showmore') === -1) {
          $('ul.listgrid').removeClass('paginated');
        } else {
          $('ul.listgrid').addClass('paginated');
        }

        if (reset) {
          target.parent().find('.listgrid-item--normal').remove();
        }

        target.replaceWith(result);
        DO.Fire('app:yt-module-events', [], true);
      },
      error() {
        target.replaceWith(
          '<p class="alert alert--themed"><span class="alert-icon"></span>Sorry, we are having technical difficulties. Please try again later</p>',
        );
      },
    });
  }

  function handleBrowserNavigation(target) {
    const { url } = window.history.state;
    const reset = true;

    handleAjax(url, target, reset);
  }

  function handleFilterLinkClick(link, target) {
    const selector = link.attr('data-replaceWithAjax');
    const url = link.attr('href');
    const category = link.attr('data-category');
    const isFilterLink = !!category;
    const isNewCategory = category !== window.history.state.category;
    const reset = isNewCategory && isFilterLink;
    const isActiveLink = link.hasClass('taglist-link--current');

    if (isActiveLink) {
      return;
    }

    updateFilterLinkClasses(link);
    pushState(link, url, selector, category);
    handleAjax(url, target, reset);
  }

  function handleMoreLinkClick(link, target) {
    const url = link.attr('href');
    const category = link.attr('data-category');
    const isFilterLink = !!category;
    const isNewCategory = category !== window.history.state.category;
    const reset = isNewCategory && isFilterLink;

    handleAjax(url, target, reset);
  }

  function replaceLinkWithAjaxResult(link, fromHistory) {
    const isFilterLink = link.data('is-filter-link');
    const target = $('li.listgrid-item.listgrid-item--showmore');

    if (fromHistory) {
      handleBrowserNavigation(target);
    } else if (isFilterLink) {
      handleFilterLinkClick(link, target);
    } else {
      handleMoreLinkClick(link, target);
    }
  }

  function attachEvents() {
    $(document).on('click', '[data-replaceWithAjax]', (event) => {
      event.preventDefault();
      replaceLinkWithAjaxResult($(event.target));
    });

    window.onpopstate = (event) => {
      const link = $(`#${event.state.linkId}`);
      updateFilterLinkClasses(link);
      replaceLinkWithAjaxResult(link, true);
    };
  }

  function init() {
    attachEvents();
    setInitialHistoryState();
    const urlCategory = getCategoryFormUrl();
    clickOnFilterLink(urlCategory);
  }

  init();
});
